import React from 'react';
import { GraduationCap, Mail, Phone, MapPin } from 'lucide-react';

const TrustFooter = () => {
  return (
    <footer className="bg-foreground text-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <GraduationCap className="w-6 h-6 text-primary" />
              <h3 className="font-display font-bold text-lg">SARVODAYA EDUCATIONAL & VOLUNTARY ASSOCIATION (SEVA) NANDED.</h3>
            </div>
            <p className="text-sm text-background/80 leading-relaxed">
              Dedicated to providing quality education to rural communities, fostering excellence, and building bright futures.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-background/80">
              <li><a href="/" className="hover:text-primary transition-colors">Home</a></li>
              <li><a href="#schools" className="hover:text-primary transition-colors">Our Schools</a></li>
              {/* <li><a href="#" className="hover:text-primary transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-primary transition-colors">Contact</a></li> */}
            </ul>
          </div>

          {/* Schools */}
          <div>
            <h4 className="font-semibold mb-4">Our Schools</h4>
            <ul className="space-y-2 text-sm text-background/80">
              <li><a href="/school/badhir" className="hover:text-primary transition-colors">NIWASI MUKH BADHIR VIDYALAY, HADGAON</a></li>
              <li><a href="/school/prathamik" className="hover:text-primary transition-colors">NIWASI MUKH BADHIR VIDYALAY, SAVARGAON</a></li>
              <li><a href="/school/madhyamik" className="hover:text-primary transition-colors">APANG NIWASI VIDYALAY, HINGOLI</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <div>
              <div className="flex space-x-4 mb-4">
                <a
                  href="https://wa.me/919503282610"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-green-500 transition-colors"
                  aria-label="Chat on WhatsApp"
                >
                  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                </a>
                <a
                  href="mailto:sevananded2000@gmail.com"
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                  aria-label="Send Email"
                >
                  <Mail className="w-6 h-6" />
                </a>
              </div>
            </div>
            <ul className="space-y-3 text-sm text-background/80">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>Nanded , India</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-primary" />
                <span>+91 95032 82610</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-primary" />
                <span>sevananded2000@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-background/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-background/70">
            <p>&copy; 2024 SARVODAYA EDUCATIONAL & VOLUNTARY ASSOCIATION (SEVA) NANDED. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TrustFooter;
